import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store';
import {
    GET_LOGGED_USER,
    GET_LOGGED_USER_FUNCTIONALITIES,
} from './types';

export const getters: GetterTree<State, RootState> = {
    [GET_LOGGED_USER](state: State) {
        return state.authUser;
    },
    [GET_LOGGED_USER_FUNCTIONALITIES](state: State) {
        return state.authUser!.functionalities;
    },
};
